<form class="edit-form" [formGroup]="form">
  <app-form>
    <app-row>
      <app-field [label]="'uuid' | caption: tableName">
        <input type="text" pInputText formControlName="uuid" />
      </app-field>

      <app-field [label]="'filename' | caption: tableName">
        <input type="text" pInputText formControlName="filename" />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'name' | caption: tableName">
        <input type="text" pInputText formControlName="name" />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'description' | caption: tableName">
        <input type="text" pInputText formControlName="description" />
      </app-field>
    </app-row>
  </app-form>
</form>
